import styled from 'styled-components';

export const ButtonsWrappers = styled.div`
  display: flex;
  gap: 12px;
  padding-top: 20px;
  padding-bottom: 24px;
`;

export const SelectCreationTypeButton = styled.div`
  height: 100%;

  border: 1px solid ${({ theme }) => theme.colors.black4};
  border-radius: 4px;
  background-color: ${({ theme }) => theme.colors.white};

  display: flex;
  padding: 16px;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 20px;
  flex: 1 0 0;
  cursor: pointer;
  transition: all 0.3s ease;

  &:hover {
    background-color: ${({ theme }) => theme.colors.black1};
  }
`;

export const IconWrapper = styled.div`
  font-size: 38px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  letter-spacing: -0.5px;
  display: flex;
  align-items: left;
  justify-content: left;
  padding: 12px;
  & img {
    width: 55px;
    height: 55px;
  }
`;

export const ButtonTitle = styled.div`
  color: ${({ theme }) => theme.colors.black9};

  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 24px;
  letter-spacing: -0.2px;
`;

export const DescriptionSpan = styled.div`
  color: ${({ theme }) => theme.colors.black7};
  font-size: 14px;
  font-weight: 400;
`;

export const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;
